import { ContentTypeModelDtoType } from 'types/services/magnolia/dtos/ContentTypeModelDto';
import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';
import { ContentTypePoolWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypePoolWorkoutDto';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';
import { PoolsActionType } from './pools.actionCreators';
import { REQUEST_POOL_FAILURE, REQUEST_POOL_SUCCESS } from './pools.actionTypes';

/*
 * General concept
 * - Pool is generic
 * - Pool has a token and ident function
 * - Ident is a simple identification method to return the right type of a pool
 */

export type PoolType = {
	token: PoolEnumType;
	ident: (data: any) => any;
	items: any[];
	ready: boolean;
};

export type GenericPoolItem = ContentTypeModelDtoType & {
	[key: string]: any;
};

export type WorkoutPoolType = PoolType & {
	ident: (...items: any[]) => ContentTypePoolWorkoutDtoType[];
};

export type RecipePoolType = PoolType & {
	ident: (...items: any[]) => ContentTypePoolRecipeDtoType[];
};

type PoolsMapType = { [id: string]: PoolType };

const castAsWorkout = (...items: any[]): ContentTypePoolWorkoutDtoType[] => items as ContentTypePoolWorkoutDtoType[];
const castAsRecipes = (...items: any[]): ContentTypePoolRecipeDtoType[] => items as ContentTypePoolRecipeDtoType[];

const pools: PoolsMapType = {
	workout: {
		token: 'workout',
		ident: castAsWorkout,
		items: [],
		ready: false,
	},
	recipe: {
		token: 'recipe',
		ident: castAsRecipes,
		items: [],
		ready: false,
	},
};

export type PoolsStateType = {
	errors: any[];
} & {
	[pool: string]: PoolType;
};

export type RootStateType = {
	pools: PoolsStateType;
};

export const initialState: PoolsStateType = ((initialPools: PoolsMapType) => {
	const state: any = {
		errors: [],
	};

	for (const poolKey in initialPools) {
		if (initialPools.hasOwnProperty(poolKey)) {
			const pool = initialPools[poolKey];

			const entry: PoolType = {
				token: pool.token,
				ident: pool.ident,
				items: pool.items || [],
				ready: pool.ready,
			};

			state[pool.token] = entry;
		}
	}

	return state;
})(pools);

export default (state: PoolsStateType = initialState, action: PoolsActionType) => {
	switch (action.type) {
		case REQUEST_POOL_SUCCESS:
			return {
				...state,
				[action.selectedPool]: {
					...state[action.selectedPool],
					items: (action as any).items,
					ready: true,
				},
			};
		case REQUEST_POOL_FAILURE:
			return {
				...state,
				errors: state.errors.concat([
					new Error(
						`[${action.selectedPool || 'pools'}] ${
							(action as any).error ? (action as any).error.message : 'Unknown'
						}`
					),
				]),
			};
		default:
			return state;
	}
};
